import {
  PHASE_ARTIFACT_ANCHORS,
  type PhaseArtifactKind,
} from '@internal/spassu-code-contract';
import type { Phase } from '../../api/types';

const KIND_BY_PHASE: Partial<Record<Phase, PhaseArtifactKind>> = {
  'gerando-prd': 'prd',
  'gerando-techspec': 'techspec',
  'dividindo-tasks': 'task',
};

const TITLE_HINT: Record<PhaseArtifactKind, string> = {
  prd: 'a 1ª linha do arquivo deve ser "# PRD — <título da atividade>"',
  techspec:
    'a 1ª linha do arquivo deve ser "# TechSpec — <título da atividade>"',
  task: 'o arquivo deve começar com "# Tarefa N.0: <título>"',
};

const TITLE_CONCEPT = 'title';

/**
 * Traduz concepts de âncora (`userNeed`, `title`, ...) para o heading literal
 * que o validador aceita. É o mesmo mapa que o backend usa na instrução de
 * reparo, vindo do contract, então UI e agente falam a mesma língua.
 */
export function describeMissingConcepts(
  phase: Phase | undefined,
  concepts: readonly string[] | undefined,
): string[] {
  const kind = phase ? KIND_BY_PHASE[phase] : undefined;
  if (!kind || !concepts || concepts.length === 0) return [];
  return concepts.map(concept => describeConcept(kind, concept));
}

function describeConcept(kind: PhaseArtifactKind, concept: string): string {
  if (concept === TITLE_CONCEPT) return TITLE_HINT[kind];
  const definition = PHASE_ARTIFACT_ANCHORS[kind].find(
    candidate => candidate.concept === concept,
  );
  if (!definition) return `falta a seção obrigatória "${concept}"`;
  return `falta a seção "## ${definition.aliases[0]}"`;
}
